// extracted by mini-css-extract-plugin
export default {"container":"copyIcon_container__kdyor","popup":"copyIcon_popup__ZKpJx"};